module.exports = __webpack_public_path__ + "media/images/flags/tw-7f28d8d889c6082c3281b04e7b90747c.svg";